import React from "react";
import AcknowledgmentModal from "../../../components/AcknowledgmentModal/AcknowledgmentModal";

export default function DisclaimerPopup({ onConfirm }) {
  return (
    <AcknowledgmentModal title="DISCLAIMER" onConfirm={onConfirm}>
      The information on this page is confidential and intended solely for
      authorized CopLine volunteers in the course of their scheduled duties. It
      contains proprietary and sensitive information related to vetted providers
      and must not be copied, shared, or discussed outside of CopLine's approved
      communication channels. Accessing this list signifies your agreement to
      uphold all confidentiality obligations as outlined in your volunteer
      agreement.
    </AcknowledgmentModal>
  );
}
